import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-hour-quarter-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(HourQuarterMultiSelectSearchControlComponent)
    ]
})
export class HourQuarterMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        const data: any[] = [];
        for (let index = 0; index < 24; index++) {
            let value: string = index.toString();
            if (index < 10) {
                value = "0" + value;
            }

            data.push({label: "'" + value + ":00" + "'", value: value + ":00"});
            data.push({label: "'" + value + ":15" + "'", value: value + ":15"});
            data.push({label: "'" + value + ":30" + "'", value: value + ":30"});
            data.push({label: "'" + value + ":45" + "'", value: value + ":45"});
        }

        this.buildData(data);
    }
}
